import {Deal, QueryPerksGoPromotionalDealsArgs, DealListSort, DealList} from "@irati/types"
import client, {QueryOptions} from "@irati/utils/services/apollo"
import {formatGeoDealsAndMarkers} from "@irati/geolocation/src/helpers/geoDeals"
import {QueryGeoDealsArgs, QueryDealsArgs, QueryDealArgs, QueryDealsInternalArgs} from "@irati/types/ops"

import {GeoDeals} from "../types"
import {getFetchPolicy} from "../helpers/apollo/fetchPolicy"
import dealQuery from "./queries/deal"
import geoDealsQuery from "./queries/geoDeals"
import perksGoPromotionalDeals from "./queries/PerksGoPromotionalDeals"
import dealListQuery, {dealListQueryKey} from "./queries/dealList"
import dealListInternalQuery, {dealListInternalQueryKey} from "./queries/dealListInternal"

// ? copy / paste from legacy deal service - not sure if its still needed
function hack({savings: {userSavings}}: Deal) {
  userSavings.value = userSavings.value ?? null
}

class DealsService {
  deal(variables: QueryDealArgs, options: QueryOptions = {}): Promise<Deal> {
    return client.query({...options, query: dealQuery, variables}).then(({data}) => {
      hack(data.deal)
      return data.deal
    })
  }

  list(variables: QueryDealsArgs, options: QueryOptions = {}): Promise<DealList> {
    return client.query({...options, query: dealListQuery, variables}).then(({data}) => data[dealListQueryKey])
  }

  listInternal(variables: QueryDealsInternalArgs, options: QueryOptions = {}): Promise<DealList> {
    return client.query({...options, query: dealListInternalQuery, variables}).then(({data}) => data[dealListInternalQueryKey])
  }

  geoDeals(boundingBox: number[], forceRefetch = false, limit = 50): Promise<GeoDeals> {
    const variables: QueryGeoDealsArgs = {
      q: "",
      geo: 1,
      slim: 1,
      limit,
      insideBoundingBox: boundingBox.join(",")
    }

    return client.query({query: geoDealsQuery, fetchPolicy: getFetchPolicy(forceRefetch), variables}).then(({data}) => {
      const {results} = data.geoDeals
      const {geoDeals, geoMarkers} = formatGeoDealsAndMarkers(results)
      return {geoDeals, geoMarkers}
    })
  }

  perksGoPromotionalDeals(
    {limit = 10, sort = DealListSort.Date}: Partial<QueryPerksGoPromotionalDealsArgs> = {},
    options: QueryOptions = {}
  ): Promise<Deal[]> {
    const variables = {
      sort,
      limit
    }
    return client.query({...options, query: perksGoPromotionalDeals, variables}).then(({data}) => data.perksGoPromotionalDeals.results)
  }
}

const service = new DealsService()

export default service
